import { isSubtypeRequired } from "@/features/properties/services/properties";
import type { SignupFormData } from "./types";

export function isStepValid(step: number, formData: SignupFormData): boolean {
  switch (step) {
    case 1:
      return Boolean(
        formData.firstName &&
          formData.lastName &&
          formData.email &&
          formData.password &&
          formData.confirmPassword &&
          formData.password === formData.confirmPassword &&
          formData.phoneNumber
      );
    case 2:
      return Boolean(formData.userType);
    case 3:
      return Boolean(formData.propertyAddress);
    case 4:
      return (
        !!formData.propertyType &&
        (!isSubtypeRequired(formData.propertyType) || !!formData.propertySubType) &&
        !!formData.propertyName
      );
    default:
      return false;
  }
}
